/**
 * Sandbox 等环境若未部署接受 form_type=generic 的后端，可仍用「Generic」产品语义存库：
 * wire 层使用 form_type=functional_test，并在 fields JSON 根上带 _fkpi_template_kind=generic。
 * 后端日后原生支持 generic 时，同库可同时存在两种表示；effectiveUiFormType 均识别为 generic。
 */

export const FKPI_TEMPLATE_KIND_KEY = "_fkpi_template_kind";

/**
 * @param {object|null|undefined} apiRecord — /api/v2/forms/ 单行
 * @returns {string|null}
 */
export function effectiveUiFormType(apiRecord) {
  if (!apiRecord || typeof apiRecord !== "object") return null;
  if (apiRecord.form_type === "generic") return "generic";
  try {
    const fields = apiRecord.fields;
    if (
      fields &&
      typeof fields === "object" &&
      !Array.isArray(fields) &&
      fields[FKPI_TEMPLATE_KIND_KEY] === "generic"
    ) {
      return "generic";
    }
  } catch (_) {
    /* ignore */
  }
  return apiRecord.form_type != null ? String(apiRecord.form_type) : null;
}

/**
 * UI 选择的 form_type + 已 normalize 的 fields → 写入 API 的 form_type / fields
 * @param {string} uiFormType
 * @param {{ rows?: unknown[], columns?: unknown[], cells?: object }} fieldsNormalized
 */
export function toWireFormPayload(uiFormType, fieldsNormalized) {
  const src =
    fieldsNormalized && typeof fieldsNormalized === "object" && !Array.isArray(fieldsNormalized)
      ? { ...fieldsNormalized }
      : { rows: [], columns: [], cells: {} };
  delete src[FKPI_TEMPLATE_KIND_KEY];
  if (uiFormType === "generic") {
    return {
      form_type: "functional_test",
      fields: { ...src, [FKPI_TEMPLATE_KIND_KEY]: "generic" },
    };
  }
  return { form_type: uiFormType, fields: src };
}
